// extracted by mini-css-extract-plugin
export default {"list":"WeatherDetails_list__jympN","heading-current-weather":"WeatherDetails_heading-current-weather__+ZqFm"};